import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import WhatsAppFloat from "@/components/layout/WhatsAppFloat";
import ScrollToTop from "@/components/layout/ScrollToTop";
import Analytics from "@/components/layout/Analytics";
import SEO, { ORG_JSONLD, PERSON_JSONLD } from "@/components/layout/SEO";

import Home from "@/pages/Home";
import Bachelor from "@/pages/Bachelor";
import Master from "@/pages/Master";
import MedicineDentistry from "@/pages/MedicineDentistry";
import PhD from "@/pages/PhD";
import VisaRelocation from "@/pages/VisaRelocation";
import EnglishExam from "@/pages/EnglishExam";
import EntryExams from "@/pages/EntryExams";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import FreeResources from "@/pages/FreeResources";
import Insights from "@/pages/Insights";
import InsightSingle from "@/pages/InsightSingle";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Analytics />
          <SEO jsonLd={[ORG_JSONLD, PERSON_JSONLD]} />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/bachelor" element={<Bachelor />} />
              <Route path="/master" element={<Master />} />
              <Route path="/medicine-dentistry" element={<MedicineDentistry />} />
              <Route path="/phd" element={<PhD />} />
              <Route path="/visa-relocation" element={<VisaRelocation />} />
              <Route path="/english-exam" element={<EnglishExam />} />
              <Route path="/entry-exams" element={<EntryExams />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/free-resources" element={<FreeResources />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<InsightSingle />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppFloat />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
